/*
  Prices in the visitor's own currency (estimates).

  Shopify stores in India charge in rupees only, so a visitor who picked, say,
  the United States still pays in INR. This script adds an estimated price in
  their own currency under each price (marked with data-elemental-cents) and
  shows a short note in the cart explaining that payment is taken in INR.

  Exchange rates come from api.frankfurter.dev (daily central-bank rates) and
  are kept for 12 hours in the visitor's browser. If the rate can't be loaded,
  nothing extra is shown and the site simply shows INR prices.

  Settings come from window.elementalFx (shop currency, visitor's country and
  language), written in layout/theme.liquid.
  Switch the feature off under Theme settings > Elemental country selector.
*/
(function () {
  /* Each country's own currency. Shopify reports INR for every country on
     this store (it is the only currency it can charge), so the theme keeps
     its own list. */
  var COUNTRY_CURRENCY = {
    AT: 'EUR', BE: 'EUR', BG: 'EUR', CY: 'EUR', DE: 'EUR', EE: 'EUR', ES: 'EUR', FI: 'EUR',
    FR: 'EUR', GR: 'EUR', HR: 'EUR', IE: 'EUR', IT: 'EUR', LT: 'EUR', LU: 'EUR', LV: 'EUR',
    MT: 'EUR', NL: 'EUR', PT: 'EUR', SI: 'EUR', SK: 'EUR', MC: 'EUR', SM: 'EUR', VA: 'EUR',
    AD: 'EUR', ME: 'EUR', XK: 'EUR',
    CZ: 'CZK', DK: 'DKK', HU: 'HUF', PL: 'PLN', RO: 'RON', SE: 'SEK', NO: 'NOK', IS: 'ISK',
    CH: 'CHF', LI: 'CHF', GB: 'GBP', US: 'USD', CA: 'CAD', MX: 'MXN', BR: 'BRL', AR: 'ARS',
    CL: 'CLP', CO: 'COP', PE: 'PEN', AU: 'AUD', NZ: 'NZD', JP: 'JPY', KR: 'KRW', CN: 'CNY',
    HK: 'HKD', TW: 'TWD', SG: 'SGD', MY: 'MYR', TH: 'THB', ID: 'IDR', PH: 'PHP', VN: 'VND',
    AE: 'AED', SA: 'SAR', QA: 'QAR', KW: 'KWD', OM: 'OMR', BH: 'BHD', IL: 'ILS', TR: 'TRY',
    ZA: 'ZAR', RU: 'RUB', UA: 'UAH', LK: 'LKR', NP: 'NPR', BD: 'BDT', PK: 'PKR', IN: 'INR'
  };

  var config = window.elementalFx;
  if (!config || !config.from) return;
  config.to = COUNTRY_CURRENCY[config.country];
  /* Visitors on India (the default country, also for foreign fans who never
     change it) see a reference price in the currency chosen in
     Theme settings > Elemental country selector, usually USD. */
  var reference = false;
  if (!config.to || config.to === config.from) {
    config.to = config.home || null;
    reference = true;
  }
  if (!config.to || config.to === config.from) return;

  var CACHE_HOURS = 12;
  var USD_TO_AED = 3.6725; /* the dirham is pegged to the US dollar */
  var cacheKey = 'elementalFx:' + config.from + ':' + config.to;

  function readCache() {
    try {
      var saved = JSON.parse(window.localStorage.getItem(cacheKey) || 'null');
      if (saved && saved.rate > 0 && Date.now() - saved.time < CACHE_HOURS * 3600 * 1000) return saved.rate;
    } catch (error) {}
    return null;
  }

  function writeCache(rate) {
    try {
      window.localStorage.setItem(cacheKey, JSON.stringify({ rate: rate, time: Date.now() }));
    } catch (error) {}
  }

  function fetchJson(url) {
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (response) {
      if (!response.ok) throw new Error('rate request failed');
      return response.json();
    });
  }

  function fetchRate(from, to) {
    return fetchJson('https://api.frankfurter.dev/v2/rate/' + from + '/' + to)
      .then(function (data) {
        if (data && data.rate > 0) return data.rate;
        throw new Error('no rate');
      })
      .catch(function () {
        return fetchJson('https://api.frankfurter.dev/v1/latest?base=' + from + '&symbols=' + to).then(function (data) {
          var rate = data && data.rates && data.rates[to];
          if (rate > 0) return rate;
          throw new Error('no rate');
        });
      });
  }

  function loadRate() {
    var cached = readCache();
    if (cached) return Promise.resolve(cached);
    var request =
      config.to === 'AED'
        ? fetchRate(config.from, 'USD').then(function (rate) { return rate * USD_TO_AED; })
        : fetchRate(config.from, config.to);
    return request.then(function (rate) {
      writeCache(rate);
      return rate;
    });
  }

  var formatter;
  function format(amount) {
    if (!formatter) {
      var locale = (config.locale || 'en') + '-' + (reference ? 'US' : config.country || '');
      try {
        formatter = new Intl.NumberFormat(locale, { style: 'currency', currency: config.to });
      } catch (error) {
        formatter = new Intl.NumberFormat('en', { style: 'currency', currency: config.to });
      }
    }
    var text = formatter.format(amount);
    return text.indexOf(config.to) === -1 ? text + ' ' + config.to : text;
  }

  function fill(rate) {
    document.querySelectorAll('[data-elemental-cents]').forEach(function (node) {
      var cents = parseFloat(node.getAttribute('data-elemental-cents'));
      if (!(cents > 0)) return;
      var text = '\u2248 ' + format((cents / 100) * rate);
      if (node.textContent !== text) node.textContent = text;
      node.hidden = false;
    });
    /* The "you pay in INR" note is only for visitors from other countries. */
    if (!reference) {
      document.querySelectorAll('[data-elemental-fx-note]').forEach(function (node) {
        node.hidden = false;
      });
    }
  }

  loadRate()
    .then(function (rate) {
      fill(rate);
      /* Prices are re-drawn when a size or colour is picked, or the cart
         changes, so fill in any new ones as they appear. */
      var timer;
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(function () { fill(rate); }, 50);
      }).observe(document.body, { childList: true, subtree: true });
    })
    .catch(function () {
      /* No rate available: leave the INR prices as they are. */
    });
})();
